export const not = predictor => (...args) => !predictor(...args);
